module.exports = __webpack_public_path__ + "static/img/7-g.36c3806c.png";